import React, { useState, useEffect } from "react";
import { Accordion } from "react-bootstrap";
import Elimination from "./Elimination";
import LineupRequirements from "./LineupRequirements";


const ScoringRules = (props) => {
    
        const [contestData, setContestData] = useState(props.contestData);
        const [defaultAccordion, setDefaultAccordion] = useState(props.defaultAccordion);

    return (
         <Accordion defaultActiveKey={defaultAccordion} className="rules-accordion">
                               
                               

                                 <Elimination/>

                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Scoring Rules</Accordion.Header>
                                    <Accordion.Body>
                                      <div className="scoring-data rules-card-data">
                                            <div className="player-position">
                                                <h4>OFFENSIVE SCORE</h4>
                                                <div className="info-block">
                                                    <h5>Passing Scoring rules </h5>
                                                    <p>For each passing yard: 0.04 point </p>
                                                    <p>For each passing TD: 4 points</p>
                                                </div>
                                                <div className="info-block">
                                                    <h5>Rushing Scoring rule</h5>
                                                    <p>For each rushing yard: 0.1 point </p>
                                                </div>
                                                <div className="info-block">
                                                    <h5>Reception Scoring rules</h5>
                                                    <p>For each receiving yard: 0.1 point </p>
                                                    <p>For each reception: 1 point</p>
                                                </div>
                                                <div className="info-block">
                                                    <h5>All other TDS (rushing, reception, turn over recoveries ): 6 points</h5>
                                                    <h5>Two point conversion: 2 points</h5><h5>All turnovers: -2</h5>
                                                </div>
                                            </div>
                                            <div className="player-position kicker-card"><h4>KICKER</h4><p>Extra points: 1 point</p>
                                                <p>Field Goal 0-39: 3 points</p>
                                                <p>Field Goal 40-49: 4 points</p><p>Field Goal 50+:  5 points</p>
                                            </div>
                                            <div className="player-position "><h4>DST</h4>
                                                <p>All TDS: 6 points</p>
                                                <p>All turnovers: 2 points</p>
                                                <p>Sacks: 1 point</p><p>Safety: 2 points</p>
                                            </div>
                                        </div>
                                        
                                    </Accordion.Body>
                                </Accordion.Item>

                                
                                <LineupRequirements/>
                              
                            </Accordion>

    )
}

export default ScoringRules

